




































































import {
  Component,
  Prop,
  Mixins,
} from 'vue-property-decorator';
import ModelManagementMixin from '@/mixins/ts/ModelManagementMixin';
import { formatErrorForNotification } from '@/utils/error';
import PaymentRemittanceRepository from '@/repositories/PaymentRemittanceRepository';
import PaymentRemittance from '@/domain/models/PaymentRemittance';

interface IDialogModel {
  open: boolean,
}

@Component
export default class PaymentRemittancesDownloadReceipt
  extends Mixins<ModelManagementMixin<IDialogModel>>(ModelManagementMixin) {
  @Prop({ type: Array as () => Array<number> }) readonly companies!: Array<number>;
  @Prop({
      type: Array as () => Array<PaymentRemittance>, required: true,
  }) readonly items!: Array<PaymentRemittance>;

  readonly repository = new PaymentRemittanceRepository();
  loading: boolean = false;

  close() {
    this.model.open = false;
  }

  private downloadBlob(response: Blob, filename: string) {
    const blobUrl = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
    window.URL.revokeObjectURL(blobUrl);
  }

  async download(type: 'together' | 'separate' | 'compress') {
    try {
      this.loading = true;
      const group = this.$session.get('company_group_id');
      const idCustomers = this.items.map((i) => i.id_customer);
      const response = await this.repository.downloadReceipts(
        group,
        this.companies,
        idCustomers,
        type,
      );

      const ext = (type === 'compress' || type === 'separate') ? 'zip' : 'pdf';
      const filename = `Comprovantes-Remessas-${new Date().toISOString().slice(0, 10)}.${ext}`;
      this.downloadBlob(response, filename);
      this.close();
    } catch (error: any) {
      const message = formatErrorForNotification(error);
      this.$notification.error(message);
    } finally {
      this.loading = false;
    }
  }
}
